import { api } from "./api.service";
import { store } from "../redux/store";
import { authUser, setUserInfo } from "../store/userInfoSlice";
import { ROUTES } from "../router/constants";

async function setAuth(
  token: string
): Promise<void> {
  try {
    // Set Authorization header in both possible locations (compat)
    (api.defaults.headers as any).Authorization = `Bearer ${token}`;
    if (api.defaults.headers.common) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    store.dispatch(authUser(true));
  } catch (error: any) {
    console.log("Erro", error);
  }
}

async function clearAuth(): Promise<void> {
  try {
    // Remove Authorization header safely from both locations
    if ((api.defaults.headers as any).Authorization) {
      delete (api.defaults.headers as any).Authorization;
    }
    if (api.defaults.headers.common && api.defaults.headers.common["Authorization"]) {
      delete api.defaults.headers.common["Authorization"];
    }

    // Clear persisted auth artifacts
    try { localStorage.removeItem('token'); } catch {}
    try { localStorage.removeItem('persist:userInfo'); } catch {}

    // Limpar dados do usuário
    store.dispatch(authUser(false));
    store.dispatch(setUserInfo({
      id: '',
      name: '',
      email: '',
      role: '',
      profile: null
    }));
  } catch (error: any) {
    console.log("Erro", error);
  }
}

async function logout(): Promise<void> {
  await clearAuth();
  try {
    window.location.replace(ROUTES.SIGNIN);
  } catch {
    // Fallback in unlikely environments without replace
    window.location.href = ROUTES.SIGNIN;
  }
}

export { setAuth, clearAuth, logout };
